import SelectFilter from './SelectFilter';

export default class VehicleTypeFilter extends SelectFilter {
  type = 'vehicleType';

  apply(locationsToFilter, filters) {
    this.isActive = true;

    const filteredLocations = locationsToFilter.filter((location) => (filters?.department?.isSet()
      ? location.hasDepartmentWithVehicleType(
        filters.department.value,
        this.value,
      )
      : location.hasVehicleType(this.value)));

    return filteredLocations;
  }
}
